import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChatBubble = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.5 8.5H12.5M7.5 12H15.5M7.5 18V20.3355C7.5 20.8684 7.5 21.1348 7.60923 21.2716C7.70422 21.3906 7.84827 21.4599 8.00054 21.4597C8.17563 21.4595 8.38367 21.2931 8.79976 20.9602L11.1852 19.0518C11.6725 18.662 11.9162 18.4671 12.1875 18.3285C12.4282 18.2055 12.6844 18.1156 12.9492 18.0613C13.2477 18 13.5597 18 14.1837 18H16.7C18.3802 18 19.2202 18 19.862 17.673C20.4265 17.3854 20.8854 16.9265 21.173 16.362C21.5 15.7202 21.5 14.8802 21.5 13.2V7.8C21.5 6.11984 21.5 5.27976 21.173 4.63803C20.8854 4.07354 20.4265 3.6146 19.862 3.32698C19.2202 3 18.3802 3 16.7 3H8.3C6.61984 3 5.77976 3 5.13803 3.32698C4.57354 3.6146 4.1146 4.07354 3.82698 4.63803C3.5 5.27976 3.5 6.11984 3.5 7.8V14C3.5 14.93 3.5 15.395 3.60222 15.7765C3.87962 16.8117 4.68827 17.6204 5.72354 17.8978C6.10504 18 6.57003 18 7.5 18Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgChatBubble;
